@if ({ toasters: toasters$ | async }; as content) {
  <div class="container-toaster">
    @for (toaster of content.toasters; track toaster) {
      <toaster-item [toaster]="toaster"></toaster-item>
    }
  </div>
}
